var map = {
	"./arrow-left-button.svg": "a788",
	"./arrow-right-button.svg": "b13c",
	"./bag.svg": "47fd",
	"./cart-f.svg": "e06a",
	"./cart.svg": "daca",
	"./catalog-f.svg": "cbe1",
	"./chat.svg": "9b69",
	"./close-grey.svg": "8066",
	"./close-white.svg": "72e4",
	"./close.svg": "8b1b",
	"./compare-full.svg": "e9d4",
	"./compare.svg": "c49d",
	"./delete.svg": "0d45",
	"./delivery.svg": "4a78",
	"./filters.svg": "1d60",
	"./heart-fill.svg": "587a",
	"./heart-fill1.svg": "b46d",
	"./heart.svg": "7d16",
	"./home-f.svg": "c5f6",
	"./info (1).svg": "9b47",
	"./info.png": "e810",
	"./info.svg": "76ed",
	"./information (1).png": "aaca",
	"./information (1).svg": "5e64",
	"./information (2).png": "9932",
	"./information (2).svg": "47bc",
	"./information.png": "1bf2",
	"./information.svg": "e923",
	"./menu-button.svg": "9ee6",
	"./more-menu.svg": "aa53",
	"./more.svg": "0f4c",
	"./nav.svg": "2f12",
	"./next.svg": "0043",
	"./notify.svg": "c760",
	"./out.svg": "495d",
	"./phone.svg": "c3bb",
	"./play.svg": "dab1",
	"./plus.svg": "eb38",
	"./profile-f.svg": "13c3",
	"./search-f.svg": "8ebb",
	"./search.svg": "d103",
	"./self.svg": "2040",
	"./star.svg": "cc90",
	"./user.svg": "6aed",
	"./webcam.svg": "14f0",
	"./zoom.svg": "6705"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";